import React from "react";
//#region types
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { CircularProgress, Grid } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const ExportLoadingMessage: React.FC = () => (
  <Grid container direction="row">
    <Grid item className={cssExports.loadingIconContainer}>
      <CircularProgress size={20} className={cssExports.loadingIcon} />
    </Grid>
    <Grid item>
      {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.ExportReportProgress)}
    </Grid>
  </Grid>
);

export default ExportLoadingMessage;


